<template>
  <v-card :width="width" :height="height" elevation="0">
    <!-- 棒グラフの場合はグラフ描画の内容を操作する部品を追加 -->
    <v-container
      v-if="showEditor"
      :style="editorStyles"
    >
      <v-row style="justify-content: flex-start; height: 100%;" no-gutters>
        <!-- 全件表示チェックボックス -->
        <v-col
          cols="2"
          :height="editorHeight"
          style="display: flex; align-items: center; flex-direction: column;"
        >
          <v-text :style="editorTitleStyles">
            全表示
          </v-text>
          <v-simple-checkbox
            v-model="showDataAll"
            class="shrink" 
            :style="editorContentsStyles"
            :ripple="false"
          ></v-simple-checkbox>
        </v-col>

        <!-- 表示件数の選択ボックス(全件表示時は使用不可) -->
        <v-col
          cols="3"
          :height="editorHeight"
          style="display: flex; align-items: center; flex-direction: column;"
        >
          <v-text :style="editorTitleStyles">
            表示件数
          </v-text>
          <v-select
            :disabled="showDataAll"
            full-width
            hide-details
            dense
            outlined
            v-model="sliceGraph"
            :items="sliceGraphPoint"
            :style="editorContentsStyles" >
          </v-select>
        </v-col>

        <!-- 表示順変更チェックボックス(書類別の承認平均グラフ、却下率グラフでのみ表示) -->
        <v-col
          v-if="sortOrderList.length"
          cols="4"
          offset="3"
          :height="editorHeight"
          style="display: flex; align-items: center; flex-direction: column;"
        >
          <v-text :style="editorTitleStyles">
            表示順
          </v-text>
          <v-select
            v-model="graphOrder"
            full-width
            hide-details
            dense
            outlined
            @change="getSortedGraph"
            :items="sortOrderList"
            :style="editorContentsStyles">
          </v-select>
        </v-col>
      </v-row>
    </v-container>

    <!-- propsから受け取ったグラフコンポーネント表示 -->
    <keep-alive>
    <component
      :is="graphComponent"
      :style="graphStyles"
      :indexMin="indexMin"
      :indexMax="indexMax"
      ref="graphType"
    ></component>
    </keep-alive>

    <!-- 棒グラフの場合はグラフ描画の内容を操作する部品を追加 -->
    <v-container
      v-if="showEditor"
      :style="editorStyles"
    >
        <!-- 表示するデータのインデックスを切り替えるボタン群 -->
        <!-- 実装内容と同様のテンプレートが存在したが、レイアウト調整ができなかったため保留 -->
        <!-- <v-pagination
          class="custom"
          v-model="index"
          :max-height="editorHeight"
          :length="graphIndexList.length"
        ></v-pagination> -->
        <v-text :style="editorTitleStyles">全{{ graphIndexList.length }}ページ中{{ index+1 }}ページ目</v-text>
        <v-row style="justify-content: flex-start;" :style="editorContentsStyles" no-gutters>
          <v-col v-if="buttonShows('prev')" cols="15" :style="editorContentsStyles">
            <v-btn
              @click="index = index-1"
              :disabled="!index"
              elevation="0"
              class="mx-0"
              :style="editorContentsStyles"
            >
              ≪
            </v-btn>
          </v-col>
          <v-col
            v-for="i in graphIndexList.length"
            :key="i"
            :style="editorContentsStyles"
            :cols="buttonShows(i)? 15 : 'none'"
          >
            <v-btn 
              v-if="buttonShows(i)"
              @click="index = i-1" 
              :disabled="index == i-1"
              class="m-0"
              elevation="0"
              :style="editorContentsStyles"
            >
              {{ i }}
            </v-btn>
            <v-col v-else-if="i==buttonStyles.firstLength+1 || i==graphIndexList.length-buttonStyles.lastLength"
              :style="editorContentsStyles"
              class="mx-0"
              cols="15">
              <v-text>…</v-text>
            </v-col>
          </v-col>
        <v-col v-if="buttonShows('next')" cols="15" :style="editorContentsStyles">
          <v-btn 
            @click="index = index+1" 
            :disabled="index == graphIndexList.length-1" 
            elevation="0" 
            class="index-button"
            :style="editorContentsStyles"
          >
            ≫
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import GraphList from "./GraphList"

export default {
  name: "GraphObject",
  props: ["graphType", "height", "width", "styles"],
  data: function () {
    return {
      graphComponent: "",
      graphData: {},
      graphLabels: [],
      graphIndexList: [],
      graphOrder: {},
      showEditor: false,
      showDataAll: false,
      sliceGraph: 10,
      tmpSliceGraph: 0,
      index: 0,
      indexMin: "",
      indexMax: "",
      graphGetter: ""
    };
  },

  //インスタンス生成時に描画するグラフを決定
  created() {
    this.findGraph();
  },

  // グラフのデータを取得するため、refの読み込みを待ち続ける
  updated() {
    this.$nextTick();
    this.barChart();
    if(this.showEditor){
      this.getGraphData();
    }
  },

  computed:{
    // グラフのタイプに合わせて描画サイズを変更する
    graphStyles() {
      if (
        this.graphType == "documentFrequency" ||
        this.graphType == "deviceFrequency"
      ) {
        var minWH = Math.min(this.width, this.height);
        return {
          height: `${minWH}px`,
          width: `${minWH}px`,
          position: "relative",
        };
      } else if (this.graphType == "applyDocumentNumber") {
        return {
          height: `${this.height}px`,
          width: `${this.width}px`,
          display: "flex",
          fontSize: `${(this.width > this.height * 3) ? (this.height < 600) ? this.height * 0.6: this.width * this.height * 0.0007 : this.width * 0.3}px`,
          justifyContent: "center",
          alignItems: "center",
        };
      }else{
        return {
          height: `${this.height - this.editorHeight*2}px`,// グラフ編集部分はグラフの上下二か所に配置する
          width: `${this.width}px`,
          position: "relative",
        };
      }
    },

    editorHeight() {
      return this.height * 0.15
    },

    // グラフのデータを操作するエリアのスタイル設定
    // デフォルトのサイズ(3*3)のみ検討、リサイズした場合にレイアウトが崩れる可能性大
    editorStyles() {
      return {
        overflow: "hidden",
        margin: 0,
        padding: 0, 
        width: "100%",
        height: `${this.editorHeight}px`,
        fontSize: `${this.editorHeight* 0.2}px`
      }
    },

    // 操作エリアを文字列部分とチェックボックス類の表示部分に分ける
    editorTitleStyles() {
      return {
        height: `${this.editorHeight * (0.4)}px`,
      }
    },
    editorContentsStyles() {
      return {
        height: `${this.editorHeight * (0.5)}px`,
      }
    },

    // インデックスボタンの表示数設定
    buttonStyles() {
      return {
        // すべて表示する場合の個数
        minLength: 10,
        // 最初側と最後側のボタンの表示個数
        firstLength: 3,
        lastLength: 3,
        // indexの前後に表示するボタンの個数
        aroundIndexLength: 2
      }
    },
    // グラフのインデックスボタンを表示する設定
    buttonShows(){
      return (val) => {
        //前後移動ボタンはindexListが2個以上ある場合のみ表示
        if(val == "prev" || val == "next"){
          if(this.graphIndexList.length > 1)
            return true;
          else
            return false;
        }

        //graphIndexListがminLength以下の場合はすべて表示
        if(this.graphIndexList.length <= this.buttonStyles.minLength) return true;

        
        //最初側と最後側のボタンは必ず表示
        if(val<=this.buttonStyles.firstLength || val > this.graphIndexList.length-this.buttonStyles.lastLength) return true;
        //indexの前後を表示する
        if(Math.abs(this.index-(val-1))<=this.buttonStyles.aroundIndexLength) return true;
        return false
      }
    },

    // 書類別の承認平均グラフ、却下率グラフをソートするための設定
    sortOrderList() {
      if(this.graphType == "approvalDocumentTimeAverage")
        return [{text: "書類ID", value:"document_id"}, {text:"承認時間", value: "time_to_approval"}]
      else if(this.graphType == "documentRejectionRate")
        return [{text: "書類ID", value:"document_id"}, {text:"却下率", value: "rejection_rate"}]
      return []
    },

    // 1~this.graphLabels.lengthまでの配列
    // 表示件数設定に使用
    sliceGraphPoint() {
      const labelLength = new Array(this.graphLabels.length).fill().map((_, index) => {return index + 1})
      return labelLength
    }
  },

  watch:{
    graphData:function (val) {
        if(val) {
          this.getGraphLabels();
        }
    },
    graphLabels: function (val) {
      if(val.length < this.sliceGraph) {
        this.$set(this, "sliceGraph", val.length)
      }
      this.getGraphIndexList();
    },
    graphIndexList: function (val) {
      if (val) {
        this.updateIndexRange(this.index);
      }
    },
    index: function () {
      this.updateIndexRange(this.index);
    },
    sliceGraph: function () {
      this.getGraphIndexList();
    },
    showDataAll: function (val) {
      if(val) {
        this.$set(this, "tmpSliceGraph", this.sliceGraph);
        this.$set(this, "sliceGraph", 0);
      }
      else {        
        this.$set(this, "sliceGraph", this.tmpSliceGraph);
      }
    }
  },

  methods: {
    // propsからグラフのコンポーネントを決定、graphGetterがあれば設定
    findGraph() {
      const tmpGraphList = GraphList.filter((e) => {
        return e.graphType === this.graphType;
      });
      const tmpGraph = tmpGraphList.length ? tmpGraphList[0] : GraphList.slice(-1)[0];
      this.$set(this, "graphComponent", tmpGraph.component);
      this.$set(this, "graphGetter", tmpGraph.graphGetter || "");
      this.$set(this, "graphOrder", this.sortOrderList[0] || "");
    },

    // 描画したグラフが棒グラフかを確認
    barChart() {
      this.showEditor = this.$refs.graphType.chartId === "bar-chart";
    },

    // 以下棒グラフ時のみ動作
    // グラフのデータを取得
    getGraphData() {
      if(this.$refs.graphType.data.labels.length)
        this.$set(this, "graphData", this.$refs.graphType.data)
    },

    // グラフのデータ一覧からラベル(横軸)を取得
    getGraphLabels() {
      const labels = [...this.graphData.labels]
      if(labels.length)
        this.$set(this, "graphLabels", labels);
    },

    // ラベル一覧をthis.sliceGraph毎に分割(1ページに表示するグラフをリスト化)
    getGraphIndexList() {
      const length = this.graphLabels.length;
      // ラベルが分割個数以下もしくは全件表示の場合の対応(graphLabels.lengthを使ってページ数を算出しているため必要)
      if(!this.sliceGraph || length < this.sliceGraph){
        this.$set(this, "graphIndexList", [this.graphLabels[0]])
        this.$set(this, "index", 0)
      }else{
        const sliceLength = Math.ceil(length / this.sliceGraph) || 1;
        const indexlist = new Array(sliceLength)
          .fill()
          .map((_, index) => [this.graphLabels[index * this.sliceGraph], this.graphLabels[index * this.sliceGraph + this.sliceGraph-1] || ""]);
        this.$set(this, "graphIndexList", indexlist);
        this.$set(this, "index", 0);
      }
    },

    // インデックスの変更(indexMin,indexMaxは子コンポーネント側に渡す必要がある)
    updateIndexRange() {
        this.$set(this, "indexMin", this.graphIndexList.at(this.index).at(0) || "");
        this.$set(this, "indexMax", this.graphIndexList.at(this.index).at(1) || "");
    },

    // グラフをソートしたデータを取得し、ラベルを編集する
    async getSortedGraph(event) {
      if(this.graphGetter){
        // 二つ目の引数でorder_keyとは別に検索値も渡してあげればよさそう
        const filter = Object.assign(this.$parent.$parent.$parent.$parent.callCreateFilter(), {order_key: event});
        
        await this.$store.dispatch("domain/" + this.graphGetter, filter)
        this.getGraphLabels();
      }
    }
  },
};
</script>

<style scoped>
  .v-btn:not(.v-btn--round).v-size--default {
    font-size: 10px;
    min-width: 0 !important;
    width: 30px;
    max-height: 30px;
    margin: 0;
    padding: 0 !important;
  }
  .col {
    padding: 0 !important;
  }
  .col-15 {
    margin-left: 1px;
    margin-right: 1px;
    max-width: calc(100%/15);
  }
  .col-none {
    flex-basis: 0;
    flex-grow: 0;
  }
  .v-input--selection-controls__ripple {
    opacity: none;
  }

  .v-icon {
    font-size: 20px;
  }
  .v-input >>> .v-icon {
    font-size: 20px;
  }

  .v-input {
    flex: none;
    font-size: 100%;
  }

  .v-input >>> .v-input__control {
    height: 100%;
  }
  .v-input >>> .v-input__slot {
    min-height: 0 !important;
    height: 100%;
  }

  .v-input >>> .v-input__append-inner {
    align-self: center;
    margin: 0 !important;
  }
  .v-input >>> .v-input__icon--append {
    min-width: 0;
    min-height: 0;
  }
  .v-text-field >>> input {
    width: 0px;
  }

  .custom {
    max-height: 100%;
    margin: 0;
    justify-content: flex-start;
  }
  .custom /deep/ .v-pagination__navigation {
    width: 25px;
    height: 25px;
    margin: 0;
    margin-left: 3px;
    margin-right: 3px;
  }
  .custom /deep/ .v-pagination__navigation .v-icon {
    font-size: 10px;
  }
  .custom /deep/ .v-pagination__more {
    width: 25px;
    height: 25px;
    margin: 0;
    margin-left: 3px;
    margin-right: 3px;
  }
  .custom /deep/ .v-pagination__item {
    font-size: 10px;
    min-width: 0 !important;
    padding: 0 !important;
    width: 25px;
    height: 25px;
    margin: 0;
    margin-left: 3px;
    margin-right: 3px;
  }
</style>

